import React, { useState } from "react";

import MainLayout from "../layouts/Main";
import ProgramForm from "../views/forms/Program";
import ComponentForm from "../views/forms/Component";
import ProgramFunctionForm from "../views/forms/ProgramFunction";

import useGetProgramsTree from "../../hooks/programs/useGetProgramsTree";

import { ISelectedData, ITreeItemES, IComponentForTree, IProgramForTree, IProgramFunctionForTree } from "../../interfaces/tree";

const ProgramsPage = () => {
    const [selected, setSelected] = useState<ISelectedData | null>(null);
    const [expanded, setExpanded] = useState<ITreeItemES[]>([]);

    const { data: programs } = useGetProgramsTree();

    return (
        <MainLayout
            programsData={{
                programs: programs ?? [],
                selected: selected,
                setSelected: setSelected,
                expanded: expanded,
                setExpanded: setExpanded,
            }}
        >
            <div className="immployer_admin__programs__page_view">
                {selected?.level === 0 &&
                    <ProgramForm
                        programData={selected.data as IProgramForTree}
                        selected={selected}
                        setSelected={setSelected}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                }
                {selected?.level === 1 &&
                    <ComponentForm
                        componentData={selected.data as IComponentForTree}
                        selected={selected}
                        setSelected={setSelected}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                }
                {selected?.level === 2 &&
                    <ProgramFunctionForm
                        programFunctionData={selected.data as IProgramFunctionForTree}
                        selected={selected}
                        setSelected={setSelected}
                        expanded={expanded}
                        setExpanded={setExpanded}
                    />
                }
                {!selected &&
                    <div className="immployer_admin__programs_page__no_selection">
                        <br /><br />
                        <h3 className="dark_color">Add/Update Programs, Components, Functions</h3>
                        <br />
                        <p className="wt_500">Please select a program to view details. If no program is added, please add the program first.</p>
                    </div>
                }
            </div>
        </MainLayout>
    );
};

export default ProgramsPage;